import React, { useState } from "react";
import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./exportTableButtons.module.css";
import { useTableExport } from "../../hooks/useTableExport";

interface ExportTableButtonsProps {
  entity?: string;
  filters?: Record<string, any>;
  dataRows?: Record<string, any>[];
  columns?: string[];
  headers?: string[];
  title?: string;
  subtitle?: string;
  filterSummary?: string[];
  disabled?: boolean;
  size?: "small" | "medium";
}

function ExportTableButtons({
  entity,
  filters,
  dataRows,
  columns,
  headers,
  title,
  subtitle,
  filterSummary,
  disabled = false,
  size = "medium",
}: ExportTableButtonsProps) {
  const { exportTable, isExporting, error } = useTableExport();
  const [exportingFormat, setExportingFormat] = useState<"pdf" | "excel" | null>(null);

  const handleExportPdf = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setExportingFormat("pdf");
    await exportTable({
      entity: entity ?? "export",
      format: "pdf",
      filters,
      dataRows,
      columns,
      headers,
      title,
      subtitle,
      filterSummary,
    });
    setExportingFormat(null);
  };

  const handleExportExcel = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setExportingFormat("excel");
    await exportTable({
      entity: entity ?? "export",
      format: "excel",
      filters,
      dataRows,
      columns,
      headers,
      title,
      subtitle,
      filterSummary,
    });
    setExportingFormat(null);
  };

  const isDisabled = disabled || isExporting;

  return (
    <div className={styles.container}>
      <div className={styles.buttonsGroup}>
        <button
          type="button"
          className={`${styles.exportButton} ${styles.pdfButton} ${
            size === "small" ? styles.small : ""
          }`}
          onClick={handleExportPdf}
          disabled={isDisabled}
          title={t("EXPORT_PDF")}
        >
          {exportingFormat === "pdf" ? <span className={styles.spinner}>⏳</span> : ""}
          {size === "medium" && <span className={styles.label}>{t("EXPORT_PDF")}</span>}
        </button>

        <button
          type="button"
          className={`${styles.exportButton} ${styles.excelButton} ${
            size === "small" ? styles.small : ""
          }`}
          onClick={handleExportExcel}
          disabled={isDisabled}
          title={t("EXPORT_EXCEL")}
        >
          {exportingFormat === "excel" ? <span className={styles.spinner}>⏳</span> : ""}
          {size === "medium" && <span className={styles.label}>{t("EXPORT_EXCEL")}</span>}
        </button>
      </div>

      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
}

export default ExportTableButtons;
